export default "__VITE_ASSET__0175ba19__"